export default {
    url: 'products/powerocean-plus',
    include: ['cn'],
};
